const PropTypes = require('prop-types');

const S3_UPLOAD_CATEGORIES = {
  passport: {
    label: 'Passport',
    dbKey: 'passport',
    s3UploadCategory: 'passport',
    requiredForMission: true,
    hasMany: false,
    fields: [
      {
        name: 'expiration',
        label: 'Date of Expiration',
        type: PropTypes.instanceOf(Date),
      },
    ],
  },
  profilePic: {
    label: 'Profile Pic',
    dbKey: 'profilePic',
    s3UploadCategory: 'profilePic',
    hasMany: false,
  },
  waivers: {
    label: 'Waivers',
    dbKey: 'waivers',
    s3UploadCategory: 'waivers',
    hasMany: true,
    fields: [
      {
        name: 'missionId',
        label: 'Mission ID',
        type: PropTypes.string,
      },
    ],
  },
  resume: {
    label: 'Resume',
    dbKey: 'resume',
    s3UploadCategory: 'resume',
    requiredForMission: true,
    hasMany: false,
  },
  certifications: {
    label: 'Certification(s)',
    dbKey: 'certifications',
    s3UploadCategory: 'certifications',
    requiredForMission: true,
    hasMany: true,
    fields: [
      {
        name: 'name',
        label: 'Certification Name',
        type: PropTypes.string,
      },
      {
        name: 'dateEarned',
        label: 'Date Earned',
        type: PropTypes.instanceOf(Date),
      },
    ],
  },
  stateLicenses: {
    label: 'State License(s)',
    dbKey: 'stateLicenses',
    s3UploadCategory: 'stateLicenses',
    requiredForMission: true,
    hasMany: true,
    dbFields: ['expiration'], // delete
  },
  driversLicense: {
    label: 'Driver\'s License',
    dbKey: 'driversLicense',
    s3UploadCategory: 'driversLicense',
    requiredForMission: false,
    hasMany: false,
    fields: [
      {
        name: 'expirationMonth',
        label: 'Expiration Month',
        type: PropTypes.number,
      },
      {
        name: 'expirationYear',
        label: 'Expiration Year',
        type: PropTypes.number,
      },
    ],
  },
  diplomas: {
    label: 'Diploma(s)',
    dbKey: 'diplomas',
    s3UploadCategory: 'diplomas',
    requiredForMission: false,
    hasMany: true,
    dbFields: ['name', 'graduationDate'], // delete
  },
};

module.exports = {
  S3_UPLOAD_CATEGORIES,
};
